import ApiService from '@/app/framework/services/ApiServices'
import { Endpoints } from '@/app/framework/misc/Endpoints'
import { injectable } from 'tsyringe'
import { AdditionalInfoReportRepositoryInterface } from '@/data/persistences/repositories/contracts/AdditionalInfoReportRepositoryInterface'
import {
  AdditionalInfoReport,
  Export,
} from '@/domain/entities/AdditionalInfoReport'
import { AdditionalInfoReportDataMapper } from '@/data/persistences/mappers/AdditionalInfoReportDataMapper'

@injectable()
export class AdditionalInfoReportApiRepository
  implements AdditionalInfoReportRepositoryInterface {
  private service: ApiService
  private mapper: AdditionalInfoReportDataMapper

  constructor(service: ApiService, mapper: AdditionalInfoReportDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async getAll(params: Object): Promise<AdditionalInfoReport> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.REPORT_ADDITIONAL_INFO,
      params
    )
    return this.mapper.convertAdditionalInfoReportFromApi(resp)
  }
  public async getExport(params: Object): Promise<Export> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.EXPORT_INFO,
      params
    )
    return this.mapper.convertExportFileFromAPi(resp)
  }
}
